<template>
  <div class="section" v-loading="isLoading">
    <figure>
      <img
        class="premios"
        alt="Vue logo"
        :src='data.img1'
        @load="loaded"
      />
    </figure>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'Cliente',
  props: ['data'],
  setup (props) {
    const isLoading = ref(true)
    const loaded = () => {
      isLoading.value = !isLoading.value
    }
    return {
      isLoading,
      loaded
    }
  }
}
</script>
<style lang="scss" scoped>
.section{
  img{
    width: 100%;
  }
}
</style>
